// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__Jn3O4","title":"Header_title__1figS","left":"Header_left__3lPlC","clinicName":"Header_clinicName__1wZEL"};